import cn from 'classnames';
import React from 'react';

import styles from './index.module.scss';

export enum GalleryTabItem {
  All = 'all',
  Digitized = 'digitized',
  MyLibrary = 'myLibrary',
}

interface TabItem {
  key: GalleryTabItem;
  label: React.ReactNode;
  active?: true;
}

interface Props {
  items: TabItem[];
  onSwitch: (key: GalleryTabItem) => void;
  activeKey: GalleryTabItem;
}

function GalleryImageTab({ items, activeKey, onSwitch }: Props) {
  const onKeyDown = (e: React.KeyboardEvent, key: GalleryTabItem) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onSwitch(key);
    }
  };

  return (
    <div className={cn(styles.tabsContainer)} role="tablist">
      {items.map((item) => (
        <div
          className={cn(styles.tabItem, `cy-gallery-tab-${item.key}`, { [styles.active]: item.key === activeKey })}
          key={item.key}
          role="tab"
          tabIndex={0}
          aria-selected={item.key === activeKey}
          onClick={() => onSwitch(item.key)}
          onKeyDown={(e) => onKeyDown(e, item.key)}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
}

export default React.memo(GalleryImageTab);
